
// import Logo from "../Images/airbnb.png"
const Navbar = () => {
    return (
      <nav>
        <img
          src="../react-project1/Images/airbnb.png"
          alt="logo"
          className="logo"
        />
      </nav>
    );

}

export default Navbar;